import { Routes, Route, Link, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Home, BookOpen, Gamepad2, BarChart2, User } from "lucide-react";

import GuestLanding    from "./components/GuestLanding";
import "./App.css";
import logo from "./KoalaQuestLogoSmall.png";
import { Clock } from "./clock"

/* Facebook */
import ReactPixel from 'react-facebook-pixel';
import UserPrivacy from "./OnlineAgreement/userPrivacy";
import UserTermsOfService from "./OnlineAgreement/userTermsOfService";

/* ===== PET ===== */
import Mall from "./components/Mall";

/* ===== Firebase ===== */
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { getDatabase, ref, set, onDisconnect, remove} from "firebase/database";

/* ====== AUTH COMPONENTS ====== */
import Login from "./UserAuthentication/Login";
import SignUp from "./UserAuthentication/SignUp";

/* ====== LIBRARY (NEW) ====== */
import Library from "./Library/Library"; // Adjust path if needed

/* ===== GAMES ===== */
import Games from "./Games/Games"; // Adjust the path if needed
import MathAdventure from "./Games/MathAdventure/MathAdventure";
import WordWizard from "./Games/WordWizard/WordWizard";
import ChineseTyping from "./Games/ChineseTyping/ChineseTyping";
import PhaserGame from "./Games/PhaserGame/PhaserGame";
import Phasermmo from "./OnlineGame/Phasermmo";
import PlaneGame from "./Games/PlaneGame/PlaneGame";

/* ====== SUBJECTS: CHINESE ====== */
import ChineseSubject from "./ChineseSubject/ChineseSubject";
import Pinyin from "./ChineseSubject/Pinyin/Pinyin";
import Zhuyin from "./ChineseSubject/Zhuyin/Zhuyin";

/* ===== ZHUYIN ===== */
import Grade1Zhuyin from "./ChineseSubject/Zhuyin/Grade1/Grade1Zhuyin";
import Grade2Zhuyin from "./ChineseSubject/Zhuyin/Grade2/Grade2Zhuyin";
import Grade3Zhuyin from "./ChineseSubject/Zhuyin/Grade3/Grade3Zhuyin";
import Grade4Zhuyin from "./ChineseSubject/Zhuyin/Grade4/Grade4Zhuyin";
import Grade5Zhuyin from "./ChineseSubject/Zhuyin/Grade5/Grade5Zhuyin";
import Grade6Zhuyin from "./ChineseSubject/Zhuyin/Grade6/Grade6Zhuyin";
import Grade7Zhuyin from "./ChineseSubject/Zhuyin/Grade7/Grade7Zhuyin";

/* ===== PINYIN ===== */
import Grade1Pinyin from "./ChineseSubject/Pinyin/Grade1/Grade1Pinyin";
import Grade2Pinyin from "./ChineseSubject/Pinyin/Grade2/Grade2Pinyin";
import Grade3Pinyin from "./ChineseSubject/Pinyin/Grade3/Grade3Pinyin";

/* ====== SUBJECTS: MATH ====== */
import Math from "./Math/Math";
import Grade1MathLesson from "./Math/Grade1/Grade1MathLesson";
import MathAddingPractice from "./Math/MathPractice/MathAddingPractice";
import MathSubtractionPractice from "./Math/MathPractice/MathSubtractionPractice";
import MathMultiplicationPractice from "./Math/MathPractice/MathMultiplicationPractice";
import MathDivisionPractice from "./Math/MathPractice/MathDivisionPractice";
import MathGeometryPractice from "./Math/MathPractice/MathGeometryPractice";
import MathTrigPractice from "./Math/MathPractice/MathTrigPractice";
import TrigGraphPractice from "./Math/MathPractice/TrigGraphPractice";
import MetricConversionPractice from "./Math/MathPractice/MathMetricConversionPractice";
import MathFractionPractice from "./Math/MathPractice/MathFractionPractice";
import MathAlgebraPractice from "./Math/MathPractice/MathAlgebraPractice";
import MathWorldLifePractice from "./Math/MathPractice/MathWorldLifePractice"
import MathDataProbPractice from "./Math/MathPractice/MathDataProbPractice";

import Grade2MathLesson from "./Math/Grade2/Grade2MathLesson";
import Grade3MathLesson from "./Math/Grade3/Grade3MathLesson";
import Grade4MathLesson from "./Math/Grade4/Grade4MathLesson";
import Grade5MathLesson from "./Math/Grade5/Grade5MathLesson";
import Grade6MathLesson from "./Math/Grade6/Grade6MathLesson";
import Grade7MathLesson from "./Math/Grade7/Grade7MathLesson";
import Grade8MathLesson from "./Math/Grade8/Grade8MathLesson";
import Grade9MathLesson from "./Math/Grade9/Grade9MathLesson";
import Grade10MathLesson from "./Math/Grade10/Grade10MathLesson";
import Grade11MathLesson from "./Math/Grade11/Grade11MathLesson";
import Grade12MathLesson from "./Math/Grade12/Grade12MathLesson";

/* ====== SUBJECTS: ENGLISH ====== */
import English from "./English/English";
import Grade1EnglishLesson from "./English/Grade1/Grade1EnglishLesson";
import Grade2EnglishLesson from "./English/Grade2/Grade2EnglishLesson";
import Grade3EnglishLesson from "./English/Grade3/Grade3EnglishLesson";
import Grade4EnglishLesson from "./English/Grade4/Grade4EnglishLesson";
import Grade5EnglishLesson from "./English/Grade5/Grade5EnglishLesson";
import Grade6EnglishLesson from "./English/Grade6/Grade6EnglishLesson";
import Grade7EnglishLesson from "./English/Grade7/Grade7EnglishLesson";
import Grade8EnglishLesson from "./English/Grade8/Grade8EnglishLesson";
import Grade9EnglishLesson from "./English/Grade9/Grade9EnglishLesson";
import Grade10EnglishLesson from "./English/Grade10/Grade10EnglishLesson";
import Grade11EnglishLesson from "./English/Grade11/Grade11EnglishLesson";
import Grade12EnglishLesson from "./English/Grade12/Grade12EnglishLesson";

//English special Lesson
import PoetryModule from "./English/PoetryModule";
import ShakespeareModule from "./English/ShakespeareModule";
import EnglishSpellingPractice from "./English/EnglishPractice/EnglishSpellingPractice";
import EnglishSentenceUnscramble from "./English/EnglishPractice/EnglishSentenceUnscramble";
import EnglishListeningPractice from "./English/EnglishPractice/EnglishListeningPractice";
import EnglishFlashcards from "./English/EnglishPractice/FlashcardsGame";

/* ====== SUBJECTS: ENGINEERING ====== */
import Engineering from "./Engineering/Engineering";
import Grade1EngineeringLesson from "./Engineering/Grade1/Grade1EngineeringLesson";
import Grade2EngineeringLesson from "./Engineering/Grade2/Grade2EngineeringLesson";
import Grade3EngineeringLesson from "./Engineering/Grade3/Grade3EngineeringLesson";
import Grade4EngineeringLesson from "./Engineering/Grade4/Grade4EngineeringLesson";
import Grade5EngineeringLesson from "./Engineering/Grade5/Grade5EngineeringLesson";
import Grade6EngineeringLesson from "./Engineering/Grade6/Grade6EngineeringLesson";
import Grade7EngineeringLesson from "./Engineering/Grade7/Grade7EngineeringLesson";

/* ====== SUBJECTS: SCIENCE ====== */
import Science from "./Science/Science";
import Grade1ScienceLesson from "./Science/Grade1/Grade1ScienceLesson";
import Grade2ScienceLesson from "./Science/Grade2/Grade2ScienceLesson";
import Grade3ScienceLesson from "./Science/Grade3/Grade3ScienceLesson";
import Grade4ScienceLesson from "./Science/Grade4/Grade4ScienceLesson";
import Grade5ScienceLesson from "./Science/Grade5/Grade5ScienceLesson";
import Grade6ScienceLesson from "./Science/Grade6/Grade6ScienceLesson";
import Grade7ScienceLesson from "./Science/Grade7/Grade7ScienceLesson";
import Grade8ScienceLesson from "./Science/Grade8/Grade8ScienceLesson";
import Grade9ScienceLesson from "./Science/Grade9/Grade9ScienceLesson";
import Grade10ScienceLesson from "./Science/Grade10/Grade10ScienceLesson";
import Grade11ScienceLesson from "./Science/Grade11/Grade11ScienceLesson";
import Grade12ScienceLesson from "./Science/Grade12/Grade12ScienceLesson";
import Grade11ScienceMenu from "./Science/Grade11/Grade11ScienceMenu";
import Grade11BiologyLesson from "./Science/Grade11/Grade11BiologyLesson";
import Grade11ChemistryLesson from "./Science/Grade11/Grade11ChemistryLesson";
import Grade11PhysicsLesson from "./Science/Grade11/Grade11PhysicsLesson";
import Grade12ScienceMenu from "./Science/Grade12/Grade12ScienceMenu";
import Grade12BiologyLesson from "./Science/Grade12/Grade12BiologyLesson";
import Grade12ChemistryLesson from "./Science/Grade12/Grade12ChemistryLesson";
import Grade12PhysicsLesson from "./Science/Grade12/Grade12PhysicsLesson";

/* ===== Science Practice */
import ScienceVocabularyPractice from "./Science/SciencePractice/ScienceVocabPractice/ScienceVocabularyPractice";
import ScienceJeopardy from "./Science/SciencePractice/ScienceJeopardy/ScienceJeopardy";
import ChemistryCalculationPracticeTool from "./Science/SciencePractice/ChemistryCalculationPracticeTool/ChemistryCalculationPracticeTool";
import PhysicsCalculationPracticeTool from "./Science/SciencePractice/PhysicsCalculationPracticeTool/PhysicsCalculationPracticeTool";
import BiologyCalculationPracticeTool from "./Science/SciencePractice/BiologyCalculationPracticeTool/BiologyCalculationPracticeTool";
import EarthSciencePracticeTool from "./Science/SciencePractice/EarthScienceCalculationPracticeTool/EarthScienceCalculationPracticeTool";
import AdvancedChemistryPractice from "./Science/AdvancedChemistryPractice/AdvancedChemistryPractice";

/* ====== SUBJECTS: RELIGION ====== */
import Religion from "./Religion/Religion";
import RCQuickQuiz from "./Religion/RomanCatholic/RCQuickQuiz";

/* ===== SUBJECTS: HISTORY ===== */
import History from "./History/History";
import Prehistoric from "./History/eras/Prehistoric";
import AncientEgypt from "./History/eras/AncientEgypt";
import AncientGreeceRome from "./History/eras/AncientGreeceRome";
import Medieval from "./History/eras/Medieval";
import Renaissance from "./History/eras/Renaissance";
import IndustrialRevolution from "./History/eras/IndustrialRevolution";
import WorldWars from "./History/eras/WorldWars";
import ColdWar from "./History/eras/ColdWar";
import ModernWorld from "./History/eras/ModernWorld";
import Future from "./History/eras/Future";

/* ====== DASHBOARDS ====== */
import StudentDashboard from "./UserProfile/StudentProfile/StudentDashboard";
import ParentDashboard from "./UserProfile/ParentProfile/ParentsDashboard";
import AssistantDashboard from "./UserProfile/AssistantProfile/AssistantDashboard";

//Firestore Tracking
import { logSiteVisit } from "./UserProfile/AssistantProfile/logSiteVisit";

/* Optional: A placeholder for universal profile settings (if not integrated in dashboards) */
import ProfileSettings from "./UserProfile/ProfileSettings/ProfileSettings";

/* Default / fallback profile image */
import defaultProfile from "./UserProfile/EmptyProfile.jpg";

/* Home Page Chat Column */
import HomePage3Column from "./components/HomePage3Column";



const BottomNav = ({ user }) => {
  // 決定「個人」連結
  let profileHref = "/login";
  if (user) {
    switch (user.accountType) {
      case "Kid":       profileHref = "/UserProfile/StudentProfile";   break;
      case "Parent":    profileHref = "/ParentsDashboard";            break;
      case "Assistant": profileHref = "/UserProfile/AssistantProfile"; break;
      default:          profileHref = "/profileSettings";
    }
  }

  return (
    <nav className="mobile-bottom-nav">
      <Link to="/"><Home size={24} /></Link>
      <Link to="/library"><BookOpen size={24} /></Link>
      <Link to="/games"><Gamepad2 size={24} /></Link>
      <Link to="/profileSettings"><BarChart2 size={24} /></Link>
      <Link to={profileHref}><User size={24} /></Link>
    </nav>
  );
};

function App() {
  const [user, setUser] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [userCoins, setUserCoins] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  
  // Facebook Pixel Initialization
  useEffect(() => {
    ReactPixel.init('1334892898040954'); // <-- replace with your actual Pixel ID
  }, []);

  // Track page views on route changes
  useEffect(() => {
    ReactPixel.pageView();
  }, [location]);

  /* Log Site Visit */
  useEffect(() => {
  // 僅在登入時才 log 訪問行為（避免未登入報錯）
  if (auth.currentUser) {
    logSiteVisit();
  }
}, []);

  /* ---------- 監聽登入狀態 ---------- */
   /* ---------- Auth + live profile + presence ---------- */
  useEffect(() => {
    let offProfile = null;
    let presRef    = null;

    const offAuth = onAuthStateChanged(auth, (fbUser) => {
      if (!fbUser) {
        offProfile?.();
        presRef && remove(presRef).catch(() => {});
        setUser(null);
        setUserCoins(0);
        localStorage.removeItem("loggedInUser");
        return;
      }

      /* live /users/{uid} */
      offProfile = onSnapshot(doc(db, "users", fbUser.uid), (snap) => {
        if (!snap.exists()) return;
        const d = snap.data();
        setUser({ uid: fbUser.uid, ...d });
        setUserCoins(d.coins ?? 0);
        localStorage.setItem(
          "loggedInUser",
          JSON.stringify({ uid: fbUser.uid, ...d })
        );
      });

      /* presence (optional RTDB) */
      try {
        const rtdb = getDatabase();
        presRef = ref(rtdb, `status/${fbUser.uid}`);
        set(presRef, {
          displayName: fbUser.displayName || "",
          avatar:      fbUser.photoURL    || "",
          state:       "online",
          ts:          Date.now(),
        });
        onDisconnect(presRef).remove();
      } catch (_) {}
    });

    return () => {
      offAuth();
      offProfile?.();
    };
  }, []);

  /* ---------- 給子元件加分用 ---------- */
  const incrementUserCoins = (amount = 1) => {
    setUserCoins((prev) => prev + amount);
    setUser((prev) => {
      if (!prev) return prev;
      const updated = { ...prev, coins: (prev.coins || 0) + amount };
      localStorage.setItem("loggedInUser", JSON.stringify(updated));
      return updated;
    });
  };

  /* ---------- 登出 ---------- */
  const handleLogout = async () => {
    try {
      await signOut(auth);

      // 刪除 presence
      try {
        if (user?.uid) {
          const presRef = ref(getDatabase(), `status/${user.uid}`);
          await remove(presRef);
        }
      } catch (_) {}

      localStorage.removeItem("loggedInUser");
      setUser(null);
      setUserCoins(0);
      navigate("/");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const toggleProfileMenu = () => user && setShowProfileMenu((p) => !p);

  return (
    <div className="play2learn-app">
      {/* ========== NAVBAR ========== */}
      <header className="play2learn-header">
        <div className="header-left">
          <Link to="/">
            <img src={logo} className="play2learn-logo" alt="Play2Learn Logo" />
          </Link>
          {user && (
            <Link to="/Library" className="library-link">
              Library
            </Link>
          )}
        </div>

        <div className="navbar-title">Koala Quest Learning</div>

          {user && <Clock />} {/* ⬅️ 放在标题和个人头像之间 */}

        <nav className="play2learn-nav">
          <ul>
            {!user ? (
              <>
                <li>
                  <Link to="/login">Login</Link>
                </li>
                <li>
                  <Link to="/signup">Sign Up</Link>
                </li>
              </>
            ) : null}
          </ul>
        </nav>

        {/* -------- Profile -------- */}
        <div className="play2learn-user-profile" onClick={toggleProfileMenu}>
          <img
            src={user?.avatar || defaultProfile}
            alt="User"
            className="profile-thumbnail"
          />
          <span className="profile-name">{user ? user.firstName : "Guest"}</span>

          {user && (
            <span className="token-balance">
              {userCoins}{" "}
              <span role="img" aria-label="coins">
                💰
              </span>
            </span>
          )}

          {user && showProfileMenu && (
            <div className="profile-dropdown-menu">
              <ul>
                {user.accountType === "Kid" && (
                  <li>
                    <Link to="/UserProfile/StudentProfile">
                      Student Dashboard
                    </Link>
                  </li>
                )}
                {user.accountType === "Parent" && (
                  <li>
                    <Link to="/ParentsDashboard">Parent Dashboard</Link>
                  </li>
                )}
                {user.accountType === "Assistant" && (
                  <li>
                    <Link to="/UserProfile/AssistantProfile">
                      Assistant Dashboard
                    </Link>
                  </li>
                )}

                <li>
                  <Link to="/profileSettings">Profile Settings</Link>
                </li>
                <li>
                  <button onClick={handleLogout}>Log Out</button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </header>


        {/* MAIN CONTENT => ALL ROUTES */}
        <main className="play2learn-main">
          <Routes>
            {/* Root => 3 column layout */}
            <Route path="/"  element={user ? <HomePage3Column user={user} /> : <GuestLanding />} />
            <Route path="/" element={user ? <HomePage3Column user={user} /> : <GuestLanding />}
/>
            {/* LIBRARY PAGE ROUTE */}
            <Route path="/library" element={<Library />} />

            {/* GAMES PAGE */}
            <Route path="/games" element={<Games />} />
            <Route path="/games/MathAdventure" element={<MathAdventure />} />
            <Route path="/games/WordWizard" element={<WordWizard />} />
            <Route path="/games/ChineseTyping" element={<ChineseTyping />} />
            <Route path="/games/PhaserGame" element={<PhaserGame />} />
            <Route path="/OnlineGame" element={<Phasermmo />} />
            <Route path="/games/PlaneGame" element={<PlaneGame />} />
            
            {/* 註冊頁：預設 parent；若 path=signup/kid → kid */}
            <Route path="/signup"       element={<SignUp fixedRole="Parent" />} />
            <Route path="/signup/kid"   element={<SignUp fixedRole="Kid" />} />

            {/* Privacy & Terms of Service */}
            <Route path="/privacy" element={<UserPrivacy />} />
            <Route path="/terms" element={<UserTermsOfService />} />

            {/* Student Dashboard => only relevant if user is "Kid" */}
            <Route path="/UserProfile/StudentProfile" element={<StudentDashboard />}/>

            {/* Parent Dashboard => only relevant if user is "Parent" */}
            <Route path="/ParentsDashboard" element={<ParentDashboard />} />

            {/* Assistant Dashboard => only if user is "Assistant" */}
            <Route
              path="/UserProfile/AssistantProfile"
              element={<AssistantDashboard />}
            />

            {/* Profile Settings => open to Kid/Parent/Assistant */}
            <Route path="/profileSettings" element={<ProfileSettings />} />

            {/* Chinese */}
            <Route path="/ChineseSubject" element={<ChineseSubject />} />

            {/* Chinese Zhuyin */}
            <Route path="/ChineseSubject/Zhuyin" element={<Zhuyin />} />
            <Route path="/ChineseSubject/Zhuyin/Grade1" element={<Grade1Zhuyin />}/>
            <Route path="/ChineseSubject/Zhuyin/Grade2" element={<Grade2Zhuyin />}/>
            <Route path="/ChineseSubject/Zhuyin/Grade3" element={<Grade3Zhuyin />}/>
            <Route path="/ChineseSubject/Zhuyin/Grade4" element={<Grade4Zhuyin />}/>
            <Route path="/ChineseSubject/Zhuyin/Grade5" element={<Grade5Zhuyin />}/>
            <Route path="/ChineseSubject/Zhuyin/Grade6" element={<Grade6Zhuyin />}/>
            <Route path="/ChineseSubject/Zhuyin/Grade7" element={<Grade7Zhuyin />}/>

            {/* Chinese Pinyin */}
            <Route path="/ChineseSubject/Pinyin" element={<Pinyin />} />
            <Route
              path="/ChineseSubject/Pinyin/Grade1"
              element={<Grade1Pinyin />}
            />
            <Route
              path="/ChineseSubject/Pinyin/Grade2"
              element={<Grade2Pinyin />}
            />
            <Route
              path="/ChineseSubject/Pinyin/Grade3"
              element={<Grade3Pinyin />}
            />

            {/* Math */}
            <Route path="/math" element={<Math />} />
            <Route path="/math/grade1" element={<Grade1MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade2" element={<Grade2MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade3" element={<Grade3MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade4" element={<Grade4MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade5" element={<Grade5MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade6" element={<Grade6MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade7" element={<Grade7MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade8" element={<Grade8MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade9" element={<Grade9MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade10" element={<Grade10MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade11" element={<Grade11MathLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/grade12" element={<Grade12MathLesson onAwardTokens={incrementUserCoins} />} />

            {/* Math Practice tool */}
            <Route path="/math/practice/addition" element={<MathAddingPractice onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/practice/subtraction"   element={<MathSubtractionPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/multiplication" element={<MathMultiplicationPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/division"       element={<MathDivisionPractice onAwardTokens={incrementUserCoins}/>} />     
            <Route path="/math/practice/geometry" element={<MathGeometryPractice onAwardTokens={incrementUserCoins} />} />
            <Route path="/math/practice/trigonometry" element={<MathTrigPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/trig-graph" element={<TrigGraphPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/metric-conversion" element={<MetricConversionPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/fraction" element={<MathFractionPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/algebra" element={<MathAlgebraPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/wording-problem" element={<MathWorldLifePractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/math/practice/math-data-graph" element={<MathDataProbPractice onAwardTokens={incrementUserCoins}/> }/>

            {/* English */}
            <Route path="/English" element={<English />} />
            <Route path="/English/Grade1" element={<Grade1EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade2" element={<Grade2EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade3" element={<Grade3EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade4" element={<Grade4EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade5" element={<Grade5EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade6" element={<Grade6EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade7" element={<Grade7EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade8" element={<Grade8EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade9" element={<Grade9EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade10" element={<Grade10EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade11" element={<Grade11EnglishLesson onAwardTokens={incrementUserCoins} />} />
            <Route path="/English/Grade12" element={<Grade12EnglishLesson onAwardTokens={incrementUserCoins} />} />

            {/* English Practice */}
            <Route path="/english/practice/spelling" element={<EnglishSpellingPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/english/practice/unscramble" element={<EnglishSentenceUnscramble onAwardTokens={incrementUserCoins}/>} />
            <Route path="/english/practice/listening" element={<EnglishListeningPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/english/practice/flashcards" element={<EnglishFlashcards onAwardTokens={incrementUserCoins}/>} />
            {/* Poetry and Shakespeare */}
            <Route path="/english/poetry" element={<PoetryModule onAwardTokens={incrementUserCoins}/>} />
            <Route path="/english/shakespeare" element={<ShakespeareModule onAwardTokens={incrementUserCoins} />} />

            {/* Engineering */}
            <Route path="/Engineering" element={<Engineering />} />
            <Route path="/Engineering/Grade1" element={<Grade1EngineeringLesson />} />
            <Route path="/Engineering/Grade2" element={<Grade2EngineeringLesson />} />
            <Route path="/Engineering/Grade3" element={<Grade3EngineeringLesson />} />
            <Route path="/Engineering/Grade4" element={<Grade4EngineeringLesson />} />
            <Route path="/Engineering/Grade5" element={<Grade5EngineeringLesson />} />
            <Route path="/Engineering/Grade6" element={<Grade6EngineeringLesson />} />
            <Route path="/Engineering/Grade7" element={<Grade7EngineeringLesson />} />

            {/* Science */}
            <Route path="/Science" element={<Science />} />
            <Route path="/Science/Grade1" element={<Grade1ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade2" element={<Grade2ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade3" element={<Grade3ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade4" element={<Grade4ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade5" element={<Grade5ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade6" element={<Grade6ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade7" element={<Grade7ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade8" element={<Grade8ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade9" element={<Grade9ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade10" element={<Grade10ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade11" element={<Grade11ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/Science/Grade12" element={<Grade12ScienceLesson onAwardTokens={incrementUserCoins}/>} />
            <Route path="/science/grade11" element={<Grade11ScienceMenu />} />
            <Route path="/science/grade11/biology" element={<Grade11BiologyLesson />} />
            <Route path="/science/grade11/chemistry" element={<Grade11ChemistryLesson />} />
            <Route path="/science/grade11/physics" element={<Grade11PhysicsLesson />} />
            <Route path="/science/grade12" element={<Grade12ScienceMenu />} />
            <Route path="/science/grade12/biology" element={<Grade12BiologyLesson />} />
            <Route path="/science/grade12/chemistry" element={<Grade12ChemistryLesson />} />
            <Route path="/science/grade12/physics" element={<Grade12PhysicsLesson />} />

            {/* Science Practice tool */}
            <Route path="/science/vocab-practice" element={<ScienceVocabularyPractice onAwardTokens={incrementUserCoins}/>} />
            <Route path="/science/jeopardy" element={<ScienceJeopardy onAwardTokens={incrementUserCoins}/>} />
            <Route path="/science/chemistry-calc" element={<ChemistryCalculationPracticeTool onAwardTokens={incrementUserCoins}/>} />
            <Route path="/science/physics-calc" element={<PhysicsCalculationPracticeTool onAwardTokens={incrementUserCoins}/>} />
            <Route path="/science/biology-calc" element={<BiologyCalculationPracticeTool onAwardTokens={incrementUserCoins}/>} />
            <Route path="/science/earth-calc" element={<EarthSciencePracticeTool />} />
            <Route path="/science/advanced-chemistry" element={<AdvancedChemistryPractice />} />
            

            {/* Religion */}
            <Route path="/Religion" element={<Religion />} />
            <Route path="/Religion/RomanCatholic" element={<RCQuickQuiz />} />

            {/* History */}
            <Route path="/History" element={<History />} />
            <Route path="/eras/Prehistoric" element={<Prehistoric />} />
            <Route path="/eras/AncientEgypt" element={<AncientEgypt />} />
            <Route path="/eras/AncientGreeceRome" element={<AncientGreeceRome />} />
            <Route path="/eras/Medieval" element={<Medieval />} />
            <Route path="/eras/Renaissance" element={<Renaissance />} />
            <Route path="/eras/IndustrialRevolution" element={<IndustrialRevolution />} />
            <Route path="/eras/WorldWars" element={<WorldWars />} />
            <Route path="/eras/ColdWar" element={<ColdWar />} />
            <Route path="/eras/ModernWorld" element={<ModernWorld />} />
            <Route path="/eras/Future" element={<Future />} />

          {/* PET */}
          <Route path="/mall" element={<Mall />} />


            {/* Auth */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
          </Routes>
        </main>

        <footer className="play2learn-footer">
          <p>&copy; Koala Quest Canada. All Rights Reserved.</p>
        </footer>
        {window.innerWidth <= 500 && <BottomNav user={user} />}
      </div>
  );
}

export default App;
